import src from "IMAGE";
export default { src, width: 240, height: 48, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAATUlEQVR42gFCAL3/ABZpOKMRTil0CCQTLQgkEy0HIRIpCCcVMQgkEy4HIhIrABZmNp4QTChzCSgVMggnFDAJKhYzCzMbPwkpFTMJKxc0ZEUKGfSzwJUAAAAASUVORK5CYII="};
